module.exports = __webpack_public_path__ + "static/media/hourglass-end.efa2e303.svg";